import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Button from '@mui/material/Button';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';

import api, { authHeader } from '../../../../services/API/apiConfig';
import {
  ButtonsContainerStyled,
  MainStyled,
  ModalStyled,
  TitleStyled,
} from './NewFolder.styles';

export function NewFolder(props) {
  const { title, open, onClose, folderId, runAfterSave, kind } = props;

  const { id } = useParams();

  const [nameFolder, setNameFolder] = useState('');
  const [helperText, setHelperText] = useState(false);

  const handleCloseModal = () => {
    setHelperText(false);
    setNameFolder('');
    onClose();
  };

  const handleCreateNewFolder = async (event) => {
    event.preventDefault();
    const data = { folder: { name: nameFolder, kind } };
    if (folderId !== null) {
      if (nameFolder) {
        await api
          .patch(`/folders/${folderId}`, data, {
            headers: authHeader(),
          })
          .then(() => {
            setHelperText(false);
            setNameFolder('');
            onClose();
            runAfterSave();
          });
      } else {
        setHelperText(true);
      }
    } else if (nameFolder) {
      await api
        .post(`/constructions/${id}/folders`, data, {
          headers: authHeader(),
        })
        .then(() => {
          setHelperText(false);
          setNameFolder('');
          onClose();
          runAfterSave();
        });
    } else {
      setHelperText(true);
    }
  };

  useEffect(() => {
    if (folderId) {
      api
        .get(`/folders/${folderId}`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setNameFolder(data.name);
        });
    }
  }, [folderId]);

  return (
    <ModalStyled open={open} onClose={onClose}>
      <MainStyled>
        <TitleStyled>{title}</TitleStyled>
        <div>
          <TextField
            placeholder="nome da pasta"
            variant="outlined"
            value={nameFolder}
            onChange={(e) => setNameFolder(e.target.value)}
          />
          {helperText && (
            <FormHelperText style={{ color: 'red' }}>
              o campo está vazio
            </FormHelperText>
          )}
        </div>
        <ButtonsContainerStyled>
          <Button
            variant="contained"
            className="save"
            onClick={(e) => handleCreateNewFolder(e)}
          >
            Salvar
          </Button>
          <Button
            variant="outlined"
            className="cancel"
            onClick={handleCloseModal}
          >
            Cancelar
          </Button>
        </ButtonsContainerStyled>
      </MainStyled>
    </ModalStyled>
  );
}

NewFolder.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  folderId: PropTypes.number,
  runAfterSave: PropTypes.func.isRequired,
  kind: PropTypes.string.isRequired,
};

NewFolder.defaultProps = {
  folderId: null,
};
